import { action } from 'satcheljs/lib/legacy';
import type FilePickerViewState from '../store/schema/FilePickerViewState';
import { defaultSort } from '../utils/fileProviderInfo/filePickerListColumnInfo';

export default action('setDefaultSort')(function setDefaultSort(viewState: FilePickerViewState) {
    viewState.columnSorting = { ...defaultSort }; //This is done because default sort should be immutable, and viewState.columnSorting needs to change
});
